import React from "react";
import { Spinner as BootStrapSpinner } from "react-bootstrap";

import { emptyString, BOOTSTRAP_SPINNER_SIZE } from "../../../constants";

/**
 * Reusable Bootstrap border spinner for inbox loading states.
 */
const BootstrapSpinner = ({
  size,
  className = emptyString,
  animation = "border",
  wrapperClassName,
}) => {
  const spinner = (
    <BootStrapSpinner
      animation={animation}
      role="status"
      size={size}
      className={className}
    />
  );

  if (wrapperClassName) {
    return <div className={wrapperClassName}>{spinner}</div>;
  }

  return spinner;
};

/** Centered small spinner used for order details / survey preview loading. */
export const renderBootStrapSpinner = () => {
  return (
    <BootstrapSpinner
      size={BOOTSTRAP_SPINNER_SIZE.SM}
      wrapperClassName="d-flex align-items-center justify-content-center p-2 h-100"
    />
  );
};

export default BootstrapSpinner;
